import '../../modules/mode-components';

import * as angular from 'angular';

class ConsoleLineController {
  public consoleCtrl;
  static $inject = ['$scope', '$element'];

  constructor(private $scope, private $element) {
    $scope.active = false;
    $scope.currentLine = false;
    $scope.element = this.$element;
  }

  $onInit() {
    this.consoleCtrl.addLine(this.$scope);

    this.$element
      .on('click', () => {
        this.$scope.$evalAsync(() => {
          this.consoleCtrl.select(this.$scope);
        });
      })
      .on('mouseenter', () => {
        this.$scope.$evalAsync(() => {
          this.$scope.active = true;
          this.$element.find('.btn').css({ visibility: 'visible' });
        });
      })
      .on('mouseleave', () => {
        this.$scope.$evalAsync(() => {
          if (!this.$scope.currentLine) {
            this.$scope.active = false;
            this.$element.find('.btn').css({ visibility: 'hidden' });
          }
        });
      });
  }

  $onDestroy() {
    $(this.$element).off('click mouseenter mouseleave');
  }
}

const consoleLineComponent: angular.IComponentOptions = {
  bindings: {
    options: '<',
    index: '@',
  },
  require: {
    consoleCtrl: '^console',
  },
  template: `
<div class="console-item" ng-class="{'console-line-active': active}">
  <div class="console-index">{{index}}</div>
  <div class="console-text">{{ctrl.options.stringValue}}</div>
  <mode-clipboard-compat
    tag-classes="btn btn-filled-primary"
    [clipboard-text]="ctrl.options.stringValue"
  >
    Copy
  </mode-clipboard-compat>
</div>
`,
  controller: ConsoleLineController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('consoleLine', consoleLineComponent);
